<template>
    <div class="card" style="padding: 3px;margin: auto;">
        <div class="row g-0">
            <div class="col-lg-6">
                <div style="width: content-box">
                    <Multiselect
                        v-model="getCategory"
                        :options="categoryList"
                        mode="single"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_category') + ' (' + this.categoryList.length + ')'"
                        @select="getProductSearchDetails()"
                        @clear="resetSearchBoxFilter(1)"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div style="width: content-box">
                    <Multiselect
                        v-model="getBrand"
                        :options="brandList"
                        mode="single"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_brand') + ' (' + this.brandList.length + ')'"
                        @select="getProductSearchDetails()"
                        @clear="resetSearchBoxFilter(2)"
                    />
                </div>

            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6">
                <div style="width: content-box">
                    <Multiselect
                        v-model="getSize"
                        :options="sizeList"
                        mode="single"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_size') + ' (' + this.sizeList.length + ')'"
                        @select="getProductSearchDetails()"
                        @clear="resetSearchBoxFilter(3)"
                    />
                </div>

            </div>
            <div class="col-lg-6">
                <div style="width: content-box">
                    <Multiselect
                        v-model="getSizeDetail"
                        :options="sizeDetailList"
                        mode="single"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_size_detail') + ' (' + this.sizeDetailList.length + ')'"
                        @select="getProductSearchDetails()"
                        @clear="resetSearchBoxFilter(4)"
                    />
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6">
                <div style="width: content-box">
                    <Multiselect
                        v-model="getColor"
                        :options="colorList"
                        mode="single"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_color') + ' (' + this.colorList.length + ')'"
                        @select="getProductSearchDetails()"
                        @clear="resetSearchBoxFilter(5)"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div style="width: content-box">
                    <Multiselect
                        v-model="getMaterial"
                        :options="materialList"
                        mode="single"
                        :can-clear=true
                        :searchable="true"
                        :placeholder="this.$t('product_search_material') + ' (' + this.materialList.length + ')'"
                        @select="getProductSearchDetails()"
                        @clear="resetSearchBoxFilter(6)"
                    />
                </div>
            </div>

        </div>
        <div class="row g-0">
            <div style="width: content-box">
                <Multiselect
                    id="productSelectBoxID"
                    v-model="getProduct"
                    :options="productList"
                    mode="single"
                    :can-clear=true
                    :searchable="true"
                    :placeholder="this.$t('product_search_product') + ' (' + this.productList.length + ')'"
                    @select="selectedProduct(1)"
                    @clear="selectedProduct(0)"
                />
            </div>
        </div>
        <div v-if="!isLoading">
            <div class="row">
                <div class="col-md-6" style="text-align: left">
                    {{ $t('inventory_stock_in_size') }} :
                    <span v-if="thisProductDetail">
                            {{ thisProductDetail['size_group'] }} : {{ thisProductDetail['size_detail'] }} , {{ thisProductDetail['size_remarks'] }}
                        </span>
                </div>
                <div class="col-md-6" style="text-align: left">
                    {{ $t('inventory_stock_in_color') }} :
                    <span v-if="thisProductDetail">
                            {{ thisProductDetail['color'] }}
                        </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6" style="text-align: left">
                    {{ $t('inventory_stock_in_in_pack') }} :
                    <span v-if="thisProductDetail">
                            {{ thisProductDetail['in_pack'] }} {{ thisProductDetail['in_unit1'] }}/{{ thisProductDetail['in_unit2'] }}
                        </span>
                </div>
                <div class="col-md-6" style="text-align: left">
                    {{ $t('inventory_stock_in_out_pack') }} :
                    <span v-if="thisProductDetail">
                            {{ thisProductDetail['out_pack'] }} {{ thisProductDetail['out_unit1'] }}/{{ thisProductDetail['out_unit2'] }}
                        </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: left">
                    {{ $t('inventory_stock_in_remarks') }} :
                    <span v-if="thisProductDetail">
                            {{ thisProductDetail['remarks'] }}
                        </span>
                </div>
            </div>
        </div>
        <div v-if="isLoading">
            <div class="spinner-grow"></div>
        </div>

    </div>

</template>

<script>
import Multiselect from "@vueform/multiselect";

export default {
    name: "ProductSearchBox",
    components: {
        Multiselect,
    },
    props: {
        mode: '',
    },
    data() {
        return {
            getProduct: '',
            getCategory: '',
            getBrand: '',
            getSize: '',
            getSizeDetail: '',
            getColor: '',
            getMaterial: '',
            productList: [],
            categoryList: [],
            brandList: [],
            sizeDetailList: [],
            sizeList: [],
            colorList: [],
            materialList: [],

            thisProductDetail: '',

            isLoading: false,
        }
    },
    mounted() {
        this.getBackendData()
        this.focusOnSelectBox()
    },
    methods: {
        focusOnSelectBox(){
            document.getElementById("productSelectBoxID").focus();
        },
        resetThisProductSearchBox(){
            this.resetSearchBoxFilter(0)
            this.getProduct = ""
        },
        updateMode(getOutCode){
            this.resetSearchBoxFilter(0)
            this.getProduct = getOutCode
            // activate as user clicked
            this.selectedProduct(1)
        },
        async getBackendData() {
            this.$store.commit('setIsTopLoading', true)
            await this.getProductSearchDetails()
            this.$store.commit('setIsTopLoading', false)
        },
        async getProductSearchDetails(){
            // DO NOT MAKE NEW LINE, WILL FUCK UP BY %20, some kind of encoding shit
            await this.$mainApi.get(
`api/product/search-product?category=${this.getCategory == null ? "" : this.getCategory}&brand=${this.getBrand == null ? "" : this.getBrand}&size=${this.getSize == null ? "" : this.getSize}&sd=${this.getSizeDetail == null ? "" : this.getSizeDetail}&color=${this.getColor == null ? "" : this.getColor}&material=${this.getMaterial == null ? "" : this.getMaterial}&mode=${this.mode}`)
                .then(response => {
                    if (response.data.status === 80) {
                        // listToLoop = [sql, sqlForCategory, sqlForBrand, sqlForSize, sqlForSizeDetails, sqlForColor, sqlForMaterial]
                        // Start from 1
                        let details = response.data.details
                        this.productList = details[0]["1"]
                        this.categoryList = details[1]["2"]
                        this.brandList = details[2]["3"]
                        this.sizeList = details[3]["4"]
                        this.sizeDetailList = details[4]["5"]
                        this.colorList = details[5]["6"]
                        this.materialList = details[6]["7"]
                    }
                })
        },
        resetSearchBoxFilter(getID){
            switch (getID){
                case 0:
                    //reset all
                    break
                case 1:
                    this.getCategory = ""
                    break
                case 2:
                    this.getBrand = ""
                    break
                case 3:
                    this.getSize = ""
                    break
                case 4:
                    this.getSizeDetail = ""
                    break
                case 5:
                    this.getColor = ""
                    break
                case 6:
                    this.getMaterial = ""
                    break
            }
            this.getProductSearchDetails()
        },
        async selectedProduct(flag) {
            // 0 -> Clear, 1 -> selected
            let result = ""
            if (flag === 0) {
                this.thisProductDetail = null
                this.getProduct = null
                result = null
            } else {
                await this.getProductDetail(this.getProduct)
                result = this.thisProductDetail
            }
            console.log("Product Search Box")
            console.log({
                "status": this.getProduct === null ? 0 : 80,
                "details": result
            })
            this.$emit('returnData', {
                "status": this.getProduct === null ? 0 : 80,
                "details": result
            })
        },
        async getProductDetail(value){
            this.isLoading = true
            await this.$mainApi.get(`api/product?code=${value}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.thisProductDetail = response.data.details.product[0]
                        // this.ctnQty = response.data.details.product[0]['in_pack']*response.data.details.product[0]['out_pack']
                    }
                })
            this.isLoading = false
        },
    }
}
</script>

<style scoped>

</style>
